"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reduxForm = require("redux-form");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd.fortress;
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "checkButtonLabel", function (label) {
      var affectedPawns = Fortress.user.pawns.filter(function (r) {
        return r.name !== 'Guest';
      });
      var rows = [];
      if (label.toLowerCase().indexOf('password') !== -1) {
        affectedPawns.forEach(function (elem, index) {
          rows.push( /*#__PURE__*/_react["default"].createElement("div", {
            key: index
          }, elem.name));
        });
      }
      return rows;
    });
    return _this;
  }
  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        buttonLabel = _this$props.buttonLabel;
      var showList = this.checkButtonLabel(this.props.buttonLabel);
      return /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: handleSubmit
      }, /*#__PURE__*/_react["default"].createElement("div", null, this.props.fieldDefs.map(function (f) {
        if (f.data_type === 'string') {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: f.handle,
            className: 'form-group ' + (_this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error ? 'has-error' : '')
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "control-label"
          }, f.label), /*#__PURE__*/_react["default"].createElement("input", _extends({
            type: "text",
            className: "form-control",
            autoComplete: f.autoComplete
          }, (0, _cccisdReduxFormHelpers.domOnlyProps)(_this2.props.fields[f.handle]), {
            disabled: f.disabled
          })), _this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error && /*#__PURE__*/_react["default"].createElement("div", {
            className: "help-block"
          }, _this2.props.fields[f.handle].error));
        }
        if (f.data_type === 'password') {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: f.handle,
            className: 'form-group ' + (_this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error ? 'has-error' : '')
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "control-label"
          }, f.label), /*#__PURE__*/_react["default"].createElement("input", _extends({
            type: "password",
            className: "form-control",
            autoComplete: f.autoComplete
          }, (0, _cccisdReduxFormHelpers.domOnlyProps)(_this2.props.fields[f.handle]))), _this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error && /*#__PURE__*/_react["default"].createElement("div", {
            className: "help-block"
          }, _this2.props.fields[f.handle].error));
        }
        if (f.data_type === 'boolean') {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: f.handle,
            className: 'form-group ' + (_this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error ? 'has-error' : '')
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "control-label"
          }, f.label), /*#__PURE__*/_react["default"].createElement("input", _extends({
            type: "checkbox",
            className: "form-control"
          }, (0, _cccisdReduxFormHelpers.domOnlyProps)(_this2.props.fields[f.handle]))), _this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error && /*#__PURE__*/_react["default"].createElement("div", {
            className: "help-block"
          }, _this2.props.fields[f.handle].error));
        }
        if (f.data_type === 'enum') {
          var values = f.values;
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: f.handle,
            className: 'form-group ' + (_this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error ? 'has-error' : '')
          }, /*#__PURE__*/_react["default"].createElement("label", {
            className: "control-label"
          }, f.label), /*#__PURE__*/_react["default"].createElement("select", _extends({}, (0, _cccisdReduxFormHelpers.domOnlyProps)(_this2.props.fields[f.handle]), {
            className: "form-control",
            style: {
              width: 'auto'
            }
          }), values.map(function (item) {
            return /*#__PURE__*/_react["default"].createElement("option", {
              value: item.value,
              key: item.value
            }, item.name);
          }), _this2.props.fields[f.handle].touched && _this2.props.fields[f.handle].error && /*#__PURE__*/_react["default"].createElement("div", {
            className: "help-block"
          }, _this2.props.fields[f.handle].error)));
        }
        return /*#__PURE__*/_react["default"].createElement("div", null);
      })), showList.length !== 0 && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h5", {
        style: {
          fontWeight: 'bold'
        }
      }, "Your password will be updated for the following roles:", ' '), /*#__PURE__*/_react["default"].createElement("div", null, showList)), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary",
        title: buttonLabel,
        isLoading: submitting,
        onClick: handleSubmit
      })));
    }
  }]);
  return Form;
}(_react["default"].Component); // function mapStateToProps(state, ownProps) {
//     console.log(ownProps);
//     return {
//         initialValues: {}
//     }
// }
_defineProperty(Form, "propTypes", {
  fields: _propTypes["default"].object.isRequired,
  handleSubmit: _propTypes["default"].func.isRequired,
  submitting: _propTypes["default"].bool.isRequired,
  fieldDefs: _propTypes["default"].array.isRequired,
  pawn: _propTypes["default"].object.isRequired,
  initialValues: _propTypes["default"].object,
  buttonLabel: _propTypes["default"].string.isRequired
});
var _default = exports["default"] = (0, _reduxForm.reduxForm)({
  // fields,
  // remember_me = false,
  // because otherwise react warns about controlled/uncontrolled component
  // initialValues: {},
})(Form);